import { Navigate } from 'react-router-dom'
import { NotFoundView, PrivacyPolicy } from '@innovatrics/checkin-components'

import { MainLayout } from './main-layout'
import { SharedLinkQueryContainer } from './components/SharedLinkQueryContainer'

const routes = [
  {
    path: '/',
    element: <MainLayout />,
    children: [
      {
        path: '/',
        element: <Navigate to="/404" />,
      },
      {
        path: '/reset/:hash',
        element: <Navigate to={'/' + window.location.pathname.split('/')[1]} />,
      },
      {
        path: '/:hash',
        element: <SharedLinkQueryContainer />,
      },
      {
        path: '/:hash/:id',
        element: <SharedLinkQueryContainer />,
      },
      { path: '/privacy-policy', element: <PrivacyPolicy /> },
      { path: '404', element: <NotFoundView /> },
      { path: 'deleted', element: <NotFoundView deleted /> },
      { path: '*', element: <Navigate to="/404" /> },
    ],
  },
]

export default routes
